import { Layout } from './Layout'
import { Props } from './Props'

export default {
    layout: Layout,
    props: Props,
}